import { useMutation } from '@tanstack/react-query'
import { getProviderLogoUploadFileUrl } from '@/modules/game/api/services'
import { GetUploadFileUrlResponse } from '@/modules/operator/type'
import { UseBaseMutationOptions } from '@/core/api/type'
import { GameMutationKeys } from '@/modules/game/keys'

interface CreateFileUrlParams {
	payload: { fileExtension: string }
}

export default function useMutationCreateProviderLogoFileUrl(
	props?: UseBaseMutationOptions<GetUploadFileUrlResponse, CreateFileUrlParams>,
) {
	return useMutation({
		mutationKey: [GameMutationKeys.CreateProviderLogoFileUrl],
		mutationFn: (params) => getProviderLogoUploadFileUrl(params.payload),
		...props,
	})
}
